import React, { useState } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { useHistory, useParams } from "react-router-dom";
import api from "../../Axios";
import Swal from "sweetalert2";

const AddPersonality = () => {
  const history = useHistory();
  const { id } = useParams();

  const maritalStatusList = [
    { label: "Never Married", key: "neverMarried" },
    { label: "Divorced", key: "divorced" },
    { label: "Widow / Widower", key: "widow/widower" },
    { label: "Waiting Divorced", key: "waitingDivorce" },
  ];

  const numberOfChildrenList = ["1", "2", "3", "4", "5", "None"];

  const physicalStatusList = [
    { label: "Normal", key: "normal" },
    { label: "Differently Abled", key: "differentlyAbled" },
  ];

  const bodyTypeList = [
    { label: "Average", key: "average" },
    { label: "Athletic", key: "athletic" },
    { label: "Heavy", key: "heavy" },
    { label: "Slim", key: "slim" },
  ];

  const complexionList = [
    { label: "Very Fair", key: "veryFair" },
    { label: "Fair", key: "fair" },
    { label: "Medium", key: "medium" },
    { label: "Brown", key: "brown" },
  ];

  const heightList = [
    `4'6"`, `4'7"`, `4'8"`, `4'9"`, `4'10"`, `4'11"`,
    `5'0"`, `5'1"`, `5'2"`, `5'3"`, `5'4"`, `5'5"`,
    `5'6"`, `5'7"`, `5'8"`, `5'9"`, `5'10"`, `5'11"`,
    `6'0"`, `6'1"`, `6'2"`, `6'3"`, `6'4"`, `6'5"`,
    `6'6"`, `6'7"`, `6'8"`, `6'9"`, `6'10"`, `6'11"`, `7'0"`,
  ];

  const weightList = Array.from({ length: 100 }, (_, i) => `${41 + i}`);

  const [data, setData] = useState({
    maritalStatus: "",
    numberOfChildren: "",
    childrenLivingWithMe: "yes",
    physicalStatus: "",
    height: "",
    weight: "",
    bodyType: "",
    complexion: "",
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleChildrenLivingChange = (value) => {
    setData({ ...data, childrenLivingWithMe: value });
  };

  const getNumericHeight = (str) => {
    const match = str.match(/(\d+)'(\d+)"/);
    if (match) {
      return `${match[1]}.${match[2]}`;
    }
    return str;
  };

  const getNumericWeight = (str) => str.trim();

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: id,
      maritalStatus: data.maritalStatus,
      numberOfChildren:
        data.numberOfChildren.toLowerCase() === "none"
          ? 0
          : parseInt(data.numberOfChildren),
      childrenStayingWithMe: data.childrenLivingWithMe,
      physicalStatus: data.physicalStatus,
      height: getNumericHeight(data.height),
      weight: getNumericWeight(data.weight),
      bodyType: data.bodyType,
      complexion: data.complexion,
    };

    api
      .post("/admin/userProfile/addUserDetails/", payload)
      .then((res) => {
        Swal.fire("Success", "Personality details submitted", "success");
        history.push(`/adduser/${id}`);
      })
      .catch((err) => {
        Swal.fire("Error", err.message || "Something went wrong", "error");
      });
  };

  const styles = {
    formContainer: {
      maxWidth: 1200,
      margin: "80px 10px",
      background: "#fff",
      padding: 24,
      borderRadius: 12,
      boxShadow: "0 2px 10px rgb(0 0 0 / 0.1)",
    },
    label: {
      fontWeight: 600,
      marginBottom: 6,
      display: "block",
      color: "#222",
    },
    selectInput: {
      border: "1.5px solid #bdbdbd",
      borderRadius: 12,
      padding: "8px 12px",
      minHeight: 40,
      width: "100%",
    },
    buttonGroup: {
      display: "flex",
      gap: 12,
      marginTop: 8,
      marginBottom: 20,
    },
    button: {
      width: "100px",
      padding: "8px 0",
      borderRadius: 12,
      border: "1px solid #7b7b7b",
      cursor: "pointer",
      fontWeight: 600,
      userSelect: "none",
    },
    activeButton: {
      backgroundColor: "green",
      color: "white",
      borderColor: "green",
    },
    submitButton: {
      width: "30%",
      borderRadius: 8,
      backgroundColor: "#000",
      color: "#fff",
      fontWeight: "bold",
      padding: "10px 0",
    },
  };

  return (
    <Form onSubmit={handleSubmit} style={styles.formContainer}>
      <h4 style={{ fontWeight: 900, color: "#000", padding: "10px 0" }}>
        Personality Details
      </h4>

      {/* Marital Status */}
      <FormGroup>
        <Label style={styles.label}>Marital Status</Label>
        <Input
          type="select"
          name="maritalStatus"
          value={data.maritalStatus}
          onChange={handleChange}
          style={styles.selectInput}
        >
          <option value="">Select Marital Status</option>
          {maritalStatusList.map((item, index) => (
            <option key={index} value={item.key}>
              {item.label}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Number of Children */}
      {data.maritalStatus !== "neverMarried" && (
        <FormGroup>
          <Label style={styles.label}>Number of Children</Label>
          <Input
            type="select"
            name="numberOfChildren"
            value={data.numberOfChildren}
            onChange={handleChange}
            style={styles.selectInput}
          >
            <option value="">Select Number of Children</option>
            {numberOfChildrenList.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </Input>
        </FormGroup>
      )}

      {/* Children Staying With Me */}
      {data.maritalStatus !== "neverMarried" &&
        data.numberOfChildren !== "None" &&
         (
          <FormGroup>
            <Label style={styles.label}>Children Staying With Me</Label>
            <div style={styles.buttonGroup}>
              {["yes", "no"].map((val) => (
                <button
                  type="button"
                  key={val}
                  onClick={() => handleChildrenLivingChange(val)}
                  style={{
                    ...styles.button,
                    ...(data.childrenLivingWithMe === val
                      ? styles.activeButton
                      : { backgroundColor: "#eee", color: "#444" }),
                  }}
                >
                  {val.toUpperCase()}
                </button>
              ))}
            </div>
          </FormGroup>
        )}

      {/* Physical Status */}
      <FormGroup>
        <Label style={styles.label}>Physical Status</Label>
        <Input
          type="select"
          name="physicalStatus"
          value={data.physicalStatus}
          onChange={handleChange}
          style={styles.selectInput}
        >
          <option value="">Select Physical Status</option>
          {physicalStatusList.map((status) => (
            <option key={status.key} value={status.key}>
              {status.label}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Height */}
      <FormGroup>
        <Label style={styles.label}>Height</Label>
        <Input
          type="select"
          name="height"
          value={data.height}
          onChange={handleChange}
          style={styles.selectInput}
        >
          <option value="">Select Height</option>
          {heightList.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Weight */}
      <FormGroup>
        <Label style={styles.label}>Weight</Label>
        <Input
          type="select"
          name="weight"
          value={data.weight}
          onChange={handleChange}
          style={styles.selectInput}
        >
          <option value="">Select Weight</option>
          {weightList.map((w) => (
            <option key={w} value={w}>
              {w}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Body Type */}
      <FormGroup>
        <Label style={styles.label}>Body Type</Label>
        <Input
          type="select"
          name="bodyType"
          value={data.bodyType}
          onChange={handleChange}
          style={styles.selectInput}
        >
          <option value="">Select Body Type</option>
          {bodyTypeList.map((b) => (
            <option key={b.key} value={b.key}>
              {b.label}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Complexion */}
      <FormGroup>
        <Label style={styles.label}>Complexion</Label>
        <Input
          type="select"
          name="complexion"
          value={data.complexion}
          onChange={handleChange}
          style={styles.selectInput}
        >
          <option value="">Select Complexion</option>
          {complexionList.map((c) => (
            <option key={c.key} value={c.key}>
              {c.label}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Submit */}
      <Button type="submit" style={styles.submitButton}>
        Submit
      </Button>
    </Form>
  );
};

export default AddPersonality;